import {
  TKwikUIProgressCircleSize,
  VKwikUIProgressCircleSize
} from "./progress-circle.definitions";

export const isValidKeyValue = (key: string, value: any): boolean => {
  const isNumber = (x: number) => typeof x === "number";
  const isString = (x: string) => typeof x === "string";

  const methods = {
    color: isString,
    max: isNumber,
    size: (x: TKwikUIProgressCircleSize) =>
      VKwikUIProgressCircleSize.includes(x),
    value: isNumber
  };

  return methods[key] && methods[key](value);
};
